import { z } from "zod";

import { basicValidator, dateValidator } from "@/lib/validators";

export const Breaks = z.object({
  breaks: z.array(
    z.object({
      id: z.string().optional(),
      minTime: z.coerce.number().min(0, {
        message: "Required",
      }),
      maxTime: z.coerce.number().min(0, { message: "Required" }),
      allowed: z.coerce.number().min(0, { message: "Required" }),
      workspaceId: z.string().optional(),
    }),
  ),
});

export type Tbreaks = z.infer<typeof Breaks>;

export const Holiday = z.object({
  holidays: z.array(
    z.object({
      id: z.string().optional(),
      date: dateValidator(true, "Date is Required"),
      occassion: basicValidator(true, "Occasion is Required"),
      remarks: basicValidator(true, "Remarks is Required"),
    }),
  ),
});

export type Tholiday = z.infer<typeof Holiday>;

export const HolidaySetting = z.object({
  startTime: z.union([z.date(), z.number()]),
  endTime: z.union([z.date(), z.number()]),
  rateConversion: z.coerce.number({
    message: "Required",
    invalid_type_error: "Required",
    required_error: "Required",
  }),
});

export type TholidaySetting = z.infer<typeof HolidaySetting>;
